import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
	Box,
	Button,
	Flex,
	Heading,
	Link,
	Spacer,
	Tabs,
	TabList,
	TabPanels,
	Tab,
	TabPanel,
} from '@chakra-ui/react';

import { getAge } from '../app-data/date';
import { services } from './data';
import { indent } from '../utils';
import { docTitles, initialStructured, options } from './data';
import { Profile } from './profile';
import { Management } from './management';
import { CustomerLog } from './customerLog';
import { AdminChecklist } from './adminChecklist';
import { Process } from './process';
import { PrintProfile } from './printProfile';

export const UserTabs = ({ user: { id, admin, setUserID } }) => {
	const [loading, setLoading] = useState(true);
	const [user, setUserState] = useState({});
	const [agreement, setAgreement] = useState([]);
	const [wake, setWakeState] = useState(new Date());
	const [wakeLog, setWakeLog] = useState(new Date());
	const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);

	useEffect(() => {
		let active = true;
		async function load() {
			const res = await axios.get(`/users/${id}`, options());
			const agmt = await axios.get(`/agreement/${id}`, options());
			if (!active) {
				return;
			}
			let { structured } = res.data.user;
			structured =
				Object.keys(structured).length === 6 ? structured : initialStructured;
			setAgreement(agmt.data.agreement);
			setUserState({
				...res.data.user,
				structured,
				age: getAge(res.data.user.birth_date),
			});
			setLoading(false);
		}
		load();

		return () => {
			active = false;
		};
	}, [id, wake]);

	const setWake = date => {
		setWakeState(date);
		setIsSubmitDisabled(true);
	};

	const setUser = user => {
		setUserState(user);
		setIsSubmitDisabled(false);
	};

	const base64ToArrayBuffer = _base64Str => {
		const binaryString = window.atob(_base64Str);
		const binaryLen = binaryString.length;
		const bytes = new Uint8Array(binaryLen);
		for (let i = 0; i < binaryLen; i++) {
			const ascii = binaryString.charCodeAt(i);
			bytes[i] = ascii;
		}
		return bytes;
	};

	const showDocument = (_base64Str, _contentType) => {
		const byte = base64ToArrayBuffer(_base64Str);
		const blob = new Blob([byte], { type: _contentType });
		window.open(URL.createObjectURL(blob), '_blank');
	};

	const showPDF = () => {
		if (loading) return;
		if (!agreement.length) return;
		const [{ src, ext }] = agreement;
		showDocument(src, ext);
	};

	if (loading) return <p>Loading...</p>;

	let { firstName, lastName, loaded, service, stage, storage_link } = user;
	const backToList = () => setUserID(-1);

	return (
		<Box p={4}>
			<Flex>
				<Heading fontSize={'3xl'} pb="6">
					{`Работа с клиентом: ${firstName} ${lastName} №${indent(4, '0', id)}`}
				</Heading>
				<Spacer />
				<Button
					onClick={backToList}
					sx={{
						'@media print': {
							display: 'none',
						},
					}}
				>
					К списку клиентов
				</Button>
			</Flex>
			<Tabs isFitted variant="enclosed">
				<TabList
					sx={{
						'@media print': {
							display: 'none',
						},
					}}
				>
					<Tab>
						<Box onClick={() => setWake(new Date())}>General</Box>
					</Tab>
					<Tab>
						<Box onClick={() => setWake(new Date())}>Profile</Box>
					</Tab>
					<Tab>
						<Box onClick={() => setWake(new Date())}>Documents</Box>
					</Tab>
					<Tab>
						<Box onClick={() => setWakeLog(new Date())}>Customer log</Box>
					</Tab>
					<Tab>
						<Box onClick={() => setWake(new Date())}>Print Profile</Box>
					</Tab>
				</TabList>

				<TabPanels>
					<TabPanel px={0}>
						<Management {...{ admin, id, user, wake, setWake }} />
					</TabPanel>
					<TabPanel>
						<Profile {...{ user, setUser, setWake, isSubmitDisabled }} />
					</TabPanel>
					<TabPanel>
						{agreement.length > 0 && (
							<Button
								d="block"
								w="100%"
								mb={6}
								colorScheme="blue"
								onClick={showPDF}
							>
								View signed agreement PDF
							</Button>
						)}
						<Heading pb={6} fontSize={'xl'}>
							{docTitles[service]}
						</Heading>
						{storage_link && (
							<Link
								href={storage_link}
								target="_blank"
								d="block"
								w="100%"
								bgColor="blue.500"
								borderRadius="md"
								color="white"
								fontSize="xl"
								py="2"
								textAlign="center"
								_hover={{
									textDecoration: 'none',
								}}
							>
								{`${lastName} ${services[service]} ${indent(4, '0', id)}`}
							</Link>
						)}
						<AdminChecklist {...{ customer: id, loaded, setWake }} />
						<Process {...{ service, stage, wakeProcess: wake }} />
					</TabPanel>
					<TabPanel>
						<CustomerLog {...{ admin, id, wakeLog, setWakeLog }} />
					</TabPanel>
					<TabPanel>
						<PrintProfile {...{ user }} />
					</TabPanel>
				</TabPanels>
			</Tabs>
		</Box>
	);
};
